export const useCraftingController = () => {
  const userStore = useUserStore();
  const { $serverApi } = useNuxtApp();

  const getCraftableItems = async (merchantId: string) => {
    const res = await $serverApi<GFALResponse<CraftItems | null>>(
      `/api/merchants/${merchantId}/craftables`,
      {
        headers: constructHeaders(userStore.authToken),
      }
    );
    if (!res.payload) return { records: [], total: 0 };
    return res.payload;
  };

  const getCraftablesByCategory = async (
    merchantId: string,
    categoryId: string,
    page: number,
    pageSize: number
  ) => {
    const res = await $serverApi<GFALResponse<CraftItems | null>>(
      `/api/merchants/${merchantId}/craftables`,
      {
        headers: constructHeaders(userStore.authToken),
        query: {
          categoryId,
          page,
          pageSize,
        },
      }
    );
    if (!res.payload) return { records: [], total: 0, page: 0, totalPages: 0 };
    return res.payload;
  };

  const getCraftableItemById = async (
    craftableId: string,
    merchantId: string
  ) => {
    const res = await $serverApi<GFALResponse<CraftItem | null>>(
      `/api/merchants/${merchantId}/craftables/${craftableId}`,
      {
        headers: constructHeaders(userStore.authToken),
      }
    );
    if (!res.payload) return;
    return res.payload;
  };

  const getIngredientCopies = async (
    craftableId: string,
    merchantId: string
  ) => {
    const response = await $serverApi<GFALResponse<CraftableItems>>(
      `/api/merchants/${merchantId}/craftables/${craftableId}/collectibles`,
      {
        headers: constructHeaders(userStore.authToken),
      }
    );
    if (!response.payload) return [];
    const ingredientCopies = Object.values(response.payload).flat();
    return ingredientCopies;
  };

  const craft = async (
    craftableId: string,
    merchantId: string,
    ingredients: string[]
  ) => {
    return await $serverApi<GFALResponse<null>>(
      `/api/merchants/${merchantId}/craftables/${craftableId}/craft`,
      {
        method: "POST",
        headers: constructHeaders(userStore.authToken),
        body: {
          collectibleIds: ingredients,
        },
      }
    );
  };
  return {
    getCraftableItems,
    getCraftablesByCategory,
    getCraftableItemById,
    getIngredientCopies,
    craft,
  };
};
